import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const apiError = (e) => formatApiErrorDetail(e.response?.data?.detail) || e.message;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const STATUS_STYLES = {
  "Ready for Adoption": "bg-pine text-sand",
  "Needs Sponsor": "bg-gold text-charcoal",
  "Permanent Resident": "bg-bark text-gold",
  "Medical Care": "bg-red-700 text-sand",
  "Forever Resident": "bg-teal-700 text-sand",
  "Forever Foster": "bg-sky-800 text-sand",
};

export const money = (n) => `$${Number(n || 0).toLocaleString("en-US")}`;
